import {ICreateCampaignGoal} from "../../../../model/campaign/ICampaignsGoals";

export const initialCampaignGoal: ICreateCampaignGoal = {
    title: '',
    story: '',
    summary: '',
    isActive: false,
}